import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { deleteById } from '../_request';
import { useToast } from '../../modules/layout/components/ToastContext';


interface DeleteProfileProps {
    targetProfileId: string;
}
const  DeleteProfile = ({ targetProfileId }: DeleteProfileProps) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { showToast } = useToast();
    const [loading, setLoading] = useState(false);
    const [ open, setOpen ] = useState(false);

    const handleDelete = async () => {

        setLoading(true);

        try{
            const result: any = await deleteById('api/UserEvents/deleteuser', targetProfileId);
            const respStatus = result?.status ?? result?.response?.status;

            if (respStatus === 200 || respStatus === 204 || respStatus === undefined) {
                showToast && showToast(t('UserDeleteSuccess'), 'success');
                navigate('/find-profiles');
            } else if (respStatus === 401) {
                navigate('/auth/login');
            } else if (respStatus === 403) {
                navigate('/error/403');
            } else if (respStatus === 404) {
                showToast && showToast(t('ProfileNotFound'), 'error');
            } else if (respStatus === 500) {
                navigate('/error/500');
            } else {
                showToast && showToast(t('StatusCode', { code: String(respStatus) }), 'error');
            }
        } catch (err: any){
            console.error(err);
            showToast && showToast(t('ConnectionError', { error: String(err) }), 'error');
        } finally {
        setLoading(false);
        setOpen(false);
      }
    };
    return(
        <>
            <button className="btn gg-btn gg-btn-submit me-2" onClick={() => setOpen(true)} >
                {t('DeleteUser')}
            </button>

            {open && (
                <div className="gg-modal-overlay">
                    <div className="gg-modal">
                        <div className="gg-modal-header">
                            <h5 className="text-danger mb-0">
                                {t('ConfirmDeletion')}
                            </h5>
                        </div>

                        <div className="gg-modal-body">
                            <p className="mb-2">
                                {t('SureToDeleteUser')}
                            </p>
                            <p className="text-muted small mb-0">
                                {t('ActionIrreversible')}
                            </p>
                        </div>

                        <div className="gg-modal-footer">
                            <button className="gg-btn"
                                    onClick={() => setOpen(false)}
                                    disabled={loading}
                            >
                                {t('Cancel')}
                            </button>

                            <button className="btn btn-danger"
                                    onClick={handleDelete}
                                    disabled={loading}
                            >
                                {loading ? t('Deleting') + '…' : t('Delete')}
                            </button>
                        </div>
                    </div>
                </div>
            )}           
        </>       
    );
};
export default DeleteProfile;